'use strict';

exports.__esModule = true;
exports.getCompositeAggsQuery = exports.getAggsQuery = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _reactivecore = require('@appbaseio/reactivecore');

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var getAggsOrder = _reactivecore.helper.getAggsOrder; // extracts query options from defaultQuery if set

var extractQueryFromDefaultQuery = function extractQueryFromDefaultQuery(defaultQuery) {
  var queryToBeReturned = {};

  if (defaultQuery) {
    var evaluateQuery = defaultQuery();

    if (evaluateQuery) {
      // we should only retrieve and set the query options here.
      // [Not implemented yet] `query` key should be handled separately for
      // adding it to `queryList` in the redux store
      var query = evaluateQuery.query,
          options = _objectWithoutProperties(evaluateQuery, ['query']);

      if (options) {
        queryToBeReturned = options;
      }
    }
  }

  return queryToBeReturned;
};

var getAggsQuery = function getAggsQuery(query, props) {
  var _clonedQuery$aggs;

  var clonedQuery = query;
  var dataField = props.dataField,
      size = props.size,
      sortBy = props.sortBy,
      showMissing = props.showMissing,
      missingLabel = props.missingLabel;
  clonedQuery.size = 0;
  clonedQuery.aggs = (_clonedQuery$aggs = {}, _clonedQuery$aggs[dataField] = {
    terms: _extends({
      field: dataField,
      size: size,
      order: getAggsOrder(sortBy || 'count')
    }, showMissing ? {
      missing: missingLabel
    } : {})
  }, _clonedQuery$aggs);

  if (props.nestedField) {
    clonedQuery.aggs = {
      reactivesearch_nested: {
        nested: {
          path: props.nestedField
        },
        aggs: clonedQuery.aggs
      }
    };
  }

  return _extends({}, clonedQuery, extractQueryFromDefaultQuery(props.defaultQuery));
};

var getCompositeAggsQuery = function getCompositeAggsQuery(query, props, after) {
  var _ref, _clonedQuery$aggs2;

  var clonedQuery = query; // missing label not available in composite aggs

  var dataField = props.dataField,
      size = props.size,
      sortBy = props.sortBy,
      showMissing = props.showMissing; // composite aggs only allows asc and desc

  var order = sortBy === 'count' ? {} : {
    order: sortBy
  };
  clonedQuery.aggs = (_clonedQuery$aggs2 = {}, _clonedQuery$aggs2[dataField] = {
    composite: _extends({
      sources: [(_ref = {}, _ref[dataField] = {
        terms: _extends({
          field: dataField
        }, order, showMissing ? {
          missing_bucket: true
        } : {})
      }, _ref)],
      size: size
    }, after)
  }, _clonedQuery$aggs2);
  clonedQuery.size = 0;

  if (props.nestedField) {
    clonedQuery.aggs = {
      reactivesearch_nested: {
        nested: {
          path: props.nestedField
        },
        aggs: clonedQuery.aggs
      }
    };
  }

  return _extends({}, clonedQuery, extractQueryFromDefaultQuery(props.defaultQuery));
};

exports.getAggsQuery = getAggsQuery;
exports.getCompositeAggsQuery = getCompositeAggsQuery;